import { SVGProps, Ref, forwardRef } from 'react';

export const BottleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="m19 20-.009 1.247c-.027 1.088-.138 1.728-.577 2.167-.44.44-1.08.55-2.167.577L15 24H9l-1.247-.009c-.997-.025-1.618-.12-2.053-.473l-.114-.104c-.44-.44-.55-1.08-.577-2.167L5 20v-2.1h14z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m17.14 7.945.008.035c.288 1.109.714 2.175 1.567 4.307.141.354.212.531.248.717l.002.006c.035.186.035.377.035.758V16.1H5v-2.332c0-.381 0-.572.035-.758l.002-.006c.018-.093.044-.184.084-.295l.164-.422c.746-1.865 1.166-2.915 1.451-3.89l.116-.417.008-.035.011-.045H17.13zM6.804 13.347c-.004.018-.006.024 0 .003.003-.028.003-.023 0-.003m10.391.003.005.013-.004-.015c-.003-.02-.003-.026 0 .002"
            fill="currentColor"
        />
        <path
            d="M17 1.8h-.775l.202 1.618c.14 1.128.247 1.977.353 2.682H7.218c.052-.35.107-.733.164-1.17l.191-1.512.202-1.618H7V0h10z"
            fill="currentColor"
        />
    </svg>
));
BottleFilledSize24Glyph.displayName = 'BottleFilledSize24Glyph';
